// SEO配置文件 - 统一管理所有SEO相关的ID和验证码

const seoConfig = {
  // Google相关配置
  google: {
    // Google Analytics ID (已在index.html中配置)
    analyticsId: 'G-DEVX3LT3Y9',
    // Google Search Console验证码
    siteVerification: '6xoFZZ137g3NcOjyvPPkwKPyBesBjhVm13tS'
  },
  
  // 百度相关配置
  baidu: {
    // 百度统计ID
    analyticsId: '942bb768d43b959f1c6cd311d5f6728a',
    // 百度站长平台验证码
    siteVerification: 'codeva-50MnK8Og9o'
  },
  
  // Microsoft Clarity配置 (已在index.html中配置)
  clarity: {
    projectId: 'sxoujnb6ug'
  },
  
  // 网站基本信息
  site: {
    name: '股票信号网',
    domain: 'https://stocksignals.cn',
    title: '股票信号网 - A股龙虎榜数据分析平台 | 港股美股实时行情 | 金融工具箱',
    description: 'A股龙虎榜数据分析平台，提供实时港股美股行情，专业金融工具包含仓位管理计算器、风险评估工具。专注股票投资分析，助力投资决策。',
    keywords: 'A股龙虎榜,港股行情,美股数据,股票分析,仓位管理,金融工具,投资计算器,股票信号,实时行情,投资分析,风险管理,股票数据'
  }
};

export default seoConfig;